export default "__VITE_ASSET__B6RkUdab__"